import { useState } from "react";
import { useSudowriteStore } from "../stores/sudowriteStore";

export default function useManuscriptReportChoice() {
  const subscription = useSudowriteStore((state) => state.subscription);
  // The subscription model mutates in place; its snapshot triggers balance updates.
  useSudowriteStore((state) => state.subscriptionJSON);
  const subscriptionReady = !!subscription && subscription.fetched !== false;
  const [checked, setChecked] = useState(false);
  const isTrial = subscriptionReady && !!subscription.activeTrial();
  const paidChoice = subscriptionReady && !isTrial && !!subscription?.usesLedgers;
  const insufficientCredits = paidChoice && (!Number.isFinite(subscription.totalQuota) || subscription.totalQuota <= 0);
  // Only paid ledger users choose; trial users always get the report.
  return {
    visible: paidChoice, checked: insufficientCredits ? false : checked, setChecked, ready: subscriptionReady,
    insufficientCredits,
    showCreditCopy: isTrial || paidChoice,
    isTrial,
    enableImportReport: subscriptionReady && !insufficientCredits && (!paidChoice || checked),
  };
}
